// extracted by mini-css-extract-plugin
export default {"navContainer":"Nav_navContainer__qxSrT","navText":"Nav_navText__vsqx8","activeNavText":"Nav_activeNavText__oPPFP"};